import L from 'leaflet';

// Fix Leaflet default marker icon paths (known CRA/Webpack issue)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export const supermarketIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [20, 33], 
  iconAnchor: [10, 33], 
  popupAnchor: [1, -28], 
  shadowSize: [33, 33],
});

export const selectedIcon = new L.DivIcon({
  className: "",
  html: `<div style="width:28px;height:28px;background:#e85d04;border:3px solid white;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 2px 8px rgba(0,0,0,.35)"></div>`,
  iconSize: [28, 28], 
  iconAnchor: [14, 28], 
  popupAnchor: [0, -30],
});

export const userIcon = new L.DivIcon({
  className: "",
  html: `<div style="width:18px;height:18px;background:#2563eb;border:3px solid white;border-radius:50%;box-shadow:0 0 0 4px rgba(37,99,235,.25)"></div>`,
  iconSize: [18, 18], 
  iconAnchor: [9, 9],
});
